module.exports = __webpack_public_path__ + "static/img/__9150.f49d0c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9150.jpg
// module id = LD3W
// module chunks = 0